import {
  MDBBtn,
  MDBBtnGroup,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTextArea
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import AssignPHNumber from "../components/topviews/AssignPhoneNumbers";
import Purchase from "../components/topviews/Purchase";
import TNPortingValidationStatus from "../components/topviews/TNPortingValidationStatus";
import TNPorting from "../components/topviews/TNporting";
import UnassignPHNumber from "../components/topviews/UnassignPhoneNumber";
import ValidatePhoneNumbers from "../components/topviews/validatePhoneNumbers";
import SMSEnabledRequest from "./popups/phonenumbers/SMSEnabledRequest";
import { show_links_tab } from "../apiclients/apiurls";
import ReputationLanding from "./landingpages/ReputationLanding";

function PhoneNumbers(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [purchase, setPurchase] = useState(false);
  const toggleShowPurchase = () => setPurchase(!purchase);

  const [centredModal, setCentredModal] = useState(location?.state && location?.state?.openadd ? location.state.openadd : false);

  const toggleOpen = () => setCentredModal(!centredModal);

  const [centredModal2, setCentredModal2] = useState(false);

  const toggleOpen2 = () => setCentredModal2(!centredModal2);

  const [portingSave, setportingSave] = useState(false);

  const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
  const [basicActive, setBasicActive] = useState(
    location.state ? location.state.tab : "tab1"
  );
  const [successMessage, setSuccessMessage] = useState("");
  const [rerederFlag, setRerenderFlag] = useState(false);
  const [TabSwitchWarn, setTabSwitchWarn] = useState(false);
  const [isSmsEnabled, setIsSmsEnabled] = useState(false);
  const { t, i18n } = useTranslation();
  const [modalHeading, setModalHeading] = useState(t('TNPortingValidation'));
  const TabSwitch = () => setTabSwitchWarn(!TabSwitchWarn);
  const adminsession = JSON.parse(sessionStorage.getItem("admin_session"));
  const [isDraft, setisDraft] = useState(false);
  const [closeFlag, setcloseFlag] = useState(false);
  const isPortingAllow = (adminsession.isSuperAdmin === undefined || (adminsession.isSuperAdmin !== undefined && adminsession.isSuperAdmin))
  // const showReputation = (JSON.parse(sessionStorage.getItem("admin_session"))?.showReputation === true) ?? false;

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };
  useEffect(() => {
    const storedTab = sessionStorage.getItem("activeTab");

    if (storedTab) {
      setBasicActive(storedTab);
      sessionStorage.removeItem("activeTab");
    }
  }, []);

  const handleClose = (e) => {
    // e.preventDefault();
    if (portingSave && isDraft && !closeFlag) {
      TabSwitch();

    } else {
      setCentredModal2(false);
      setModalHeading(t("TNPortingValidation"));
      navigate("/phonenumbers", {
        state: { tab: "tab4" },
      });

      window.location.reload();
    }

  }

  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const [basicModal1, setBasicModal1] = useState(false);
  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const basicData1 = {
    columns: ["Name", "Remove"],
    rows: [
      ["Poly VVX 601", "X"],
      ["Poly VVX 601", "X"],
    ],
  };
  const [selectedRegion, setSelectedRegion] = useState("IN");

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);

  const [assigneddatabasicActive, setAssigneddatabasicActive] =
    useState("tab1");

  const handleBasicClick2 = (value) => {
    if (value === assigneddatabasicActive) {
      return;
    }

    setAssigneddatabasicActive(value);
  };

  const handleTabChange = (tab) => {
    setBasicActive(tab);
  };
  useEffect(() => {
    if (location.state?.openadd) {
      setCentredModal(true); // Open the popup when navigating from LandingPage.js
      navigate("/phonenumbers", { replace: true, state: {} }); // Reset state immediately
    }
  }, [location.state]);

  const [SMSEnableRequest, setSMSEnableRequest] = useState(false);

  const SMSEnableRequesttoggleOpen = () => setSMSEnableRequest(!SMSEnableRequest);
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={36}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0">
                      {t("PhoneNumbers")}
                    </h5>
                  </div>

                  <div className="card-body px-0">
                    <div className="row container-fluid mb-3">
                      <MDBTabs className="mb-3 d-flex justify-content-between">
                        <div className="d-flex">
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab1")}
                              active={basicActive === "tab1"}
                            >
                              {t("Assigned")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab2")}
                              active={basicActive === "tab2"}
                            >
                              {t("Unassigned")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab3")}
                              active={basicActive === "tab3"}
                            >
                              {t("Validated")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          {isPortingAllow && (
                            <MDBTabsItem>
                              <MDBTabsLink
                                onClick={() => handleBasicClick("tab4")}
                                active={basicActive === "tab4"}
                              >
                                Number Porting and Validation Status
                              </MDBTabsLink>
                            </MDBTabsItem>
                          )}
                          {/* {showReputation === true && ( */}
                            <MDBTabsItem>
                              <MDBTabsLink
                                onClick={() => handleBasicClick("tab5")}
                                active={basicActive === "tab5"}
                              >
                                Reputation
                              </MDBTabsLink>
                            </MDBTabsItem>
                          {/* )} */}




                        </div>
                        <div className="mb-1">

                          <MDBBtn className=" btn_adjust me-2" onClick={(e) => { e.preventDefault(); toggleOpen(); }}>
                            <MDBIcon fas icon="plus" size="sm" className="me-2" /> {t("add_Numbers")}
                          </MDBBtn>
                          {/* We are hiding SMS Enable Request button as per discusssion . */}

                          {/* {isSmsEnabled && (<MDBBtn className=" btn_adjust me-2" onClick={() => setSMSEnableRequest(true)}>
                            SMS Enable Request
                          </MDBBtn>)} */}
                          
                          {isPortingAllow && (
                            <MDBBtn className=" btn_adjust" onClick={toggleOpen2}>
                              {t("NumberPorting")}
                            </MDBBtn>
                          )}

                          {/* <MDBBtnGroup
                            aria-label="Button group with nested dropdown"
                            className="display-inline ms-2 btn_adjust h-inherit"
                          >
                            <MDBBtnGroup>
                              <MDBDropdown>
                                <MDBDropdownToggle className="px-3">
                                  <div className="text-white">
                                    <MDBIcon fas icon="ellipsis-v" className="me-2" />
                                    More
                                  </div>
                                </MDBDropdownToggle>
                                <MDBDropdownMenu>
                                  <MDBDropdownItem link>SMS Enabled Request</MDBDropdownItem>
                                  <MDBDropdownItem link>Caller ID Name</MDBDropdownItem>
                                </MDBDropdownMenu>
                              </MDBDropdown>
                            </MDBBtnGroup>
                          </MDBBtnGroup> */}
                        </div>
                      </MDBTabs>

                      <MDBTabsContent>
                        <MDBTabsPane open={basicActive === "tab1"}>
                          <AssignPHNumber isActive={basicActive === "tab1"}
                            setIsSmsEnabled={setIsSmsEnabled}
                          />
                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === "tab2"}>
                          <UnassignPHNumber
                            isActive={basicActive === "tab2"}
                            setSuccessMessage={setSuccessMessage}
                            successMessage={successMessage}
                            setRerenderFlag={setRerenderFlag}
                            rerederFlag={rerederFlag}

                          />
                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === "tab3"}>
                          <ValidatePhoneNumbers isActive={basicActive === "tab3"} setSuccessMessage={setSuccessMessage}
                            successMessage={successMessage} />

                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === "tab4"}>
                          <TNPortingValidationStatus isActive={basicActive === "tab4"} />
                        </MDBTabsPane>
                        {/* {showReputation === true && ( */}
                         <MDBTabsPane open={basicActive === "tab5"}>
                          <ReputationLanding isActive={basicActive === "tab5"} />
                        </MDBTabsPane>
                         {/* )} */}
                      </MDBTabsContent>
                    </div>
                  </div>
                </div>
              </section>
            </>
          }
        />
        {/* <Footer /> */}

        {/* 
        <MDBModal open={toggleShowPurchase} setShow={setPurchase} tabIndex="-1">
          <MDBModalDialog size="md">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{t("Purchase")}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={toggleShowPurchase}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>

                <Purchase
                  isActive={basicActive === "tab2"}
                  setSuccessMessage={setSuccessMessage}
                  setBasicActive={handleTabChange} />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal> */}


        {/* {centredModal && (
          <PopupLoader
            className="modal-lg"
            title={"Add Phone Number(s)"}
            content={
              <Purchase
                isActive={basicActive === "tab2"}
                setSuccessMessage={setSuccessMessage}
                setBasicActive={handleTabChange}
                onClose={toggleOpen}
                setRerenderFlag={setRerenderFlag}
              />}
            onShow={setCentredModal}
            onClose={toggleOpen}
          />
        )} */}


        <MDBModal staticBackdrop open={centredModal} onClose={() => setCentredModal(false)} tabIndex='-1' key={centredModal ? "open" : "close"}>
          <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle className="d-flex align-items-center justify-content-center">
                  Add Phone Number(s)
                </MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className="fullPageModel">
                <Purchase
                 key={centredModal ? "purchase-open" : "purchase-close"}
                  isActive={centredModal}
                  setSuccessMessage={setSuccessMessage}
                  setBasicActive={handleTabChange}
                  onClose={toggleOpen}
                  setRerenderFlag={setRerenderFlag}
                />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>


        <MDBModal open={centredModal2} onClose={(e) => { handleClose(e); }} tabIndex='-1'>
          <MDBModalDialog size="fullscreen">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle className="d-flex align-items-center justify-content-center">
                  {modalHeading}
                </MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={(e) => { handleClose(e); }}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className="fullPageModel">
                <TNPorting
                  isActive={centredModal2}
                  setSuccessMessage={setSuccessMessage}
                  setBasicActive={handleTabChange}
                  closePopup={(e) => { handleClose(e); }}
                  setRerenderFlag={setRerenderFlag}
                  portingSave={portingSave}
                  setportingSave={setportingSave}
                  TabSwitchWarn={TabSwitchWarn}
                  setTabSwitchWarn={setTabSwitchWarn}
                  setCentredModal2={setCentredModal2}
                  setModalHeading={setModalHeading}
                  setIsDraft={setisDraft}
                  setcloseFlag={setcloseFlag}
                />

              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>




        {SMSEnableRequest &&
          (<SMSEnabledRequest onClose={SMSEnableRequesttoggleOpen}
          />)
        }

        <MDBModal open={basicModal} setShow={setBasicModal} tabIndex="-1">
          <MDBModalDialog >
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{t("alert")}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={toggleShow}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <div className="row">
                  <div className="tel-numbers pt-2">
                    <h5>{t("RequestSMSEnPhoneNumbers")}:</h5>
                    <p>{t("RequestSMSEnPhoneNutxt")}</p>
                    <p className="mt-3">{t("PlEnterRemarks")}</p>
                    <MDBTextArea className="form-control" rows={4} />
                  </div>
                </div>
              </MDBModalBody>

              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={toggleShow}>
                  {t("cancel")}
                </MDBBtn>
                <MDBBtn>{t("request")}</MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <MDBModal open={basicModal1} setShow={setBasicModal1} tabIndex="-1">
          <MDBModalDialog >
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{t("add_New_User")}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={toggleShow1}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <div className="row">
                  <div className="tel-numbers pt-2">
                    <h5>{t("RequestPhoneNumbers")}:</h5>
                    <p>{t("RequestSMSEnPhoneNutxt")}</p>
                    <p className="mt-3">{t("PlEnterRemarks")}</p>
                    <MDBTextArea className="form-control" rows={4} />
                  </div>
                </div>
              </MDBModalBody>

              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={toggleShow1}>
                  {t("cancel")}
                </MDBBtn>
                <MDBBtn>{t("request")}</MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    </React.Fragment >
  );
}

export default PhoneNumbers;
